/* eslint-env jquery */

export default class TabbableInterface {
  constructor() {
    this.parent = $("[tabbable]");
    this.currentIndex = "0";
    const self = this;
    $("[tabbable-content]").each((index, element) => {
      if ($(element).attr("tabbable-index") !== self.currentIndex) {
        $(element).css("display", "none");
      }
    });
  }

  updateListener = () => {
    const selfs = this;
    $(":not(.disabled)[tabbable-tab]").each((index, element) => {
      $(element).unbind("click");
    });
    $(":not(.disabled)[tabbable-tab]").on("click", (event) => {
      selfs.showTab(event.currentTarget);
    });
  }

  showTab = (tab) => {
    // Enable tab
    this.updateListener();

    const ndx = $(tab).attr("tabbable-index");
    $(`[tabbable-tab][tabbable-index='${ndx}']`).removeClass("disabled");
    $(`[tabbable-tab][tabbable-index='${this.currentIndex}']`).removeClass("current");
    $(`[tabbable-tab][tabbable-index='${ndx}']`).addClass("current");
    this.currentIndex = ndx;

    // Show content
    $("[tabbable-content]").each((index, element) => {
      if ($(element).attr("tabbable-index") === ndx) {
        $(element).css("display", "");
      } else {
        $(element).css("display", "none");
      }
    });

    // Disable all tabs proceeding the current tab
    $(tab).nextAll().each((index, element) => {
      $(element).addClass("disabled");
      $(element).unbind("click");
    });
  }
}
